import { getTheme } from "@clipboard-health/ui-theme";
import { ThemeProvider } from "@mui/material";
import { ACCOUNTS_BASE_PATH } from "@src/appV2/redesign/Accounts/paths";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { PageContent } from "@src/appV2/redesign/WorkerShifts/components/PageContent";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import React from "react";

export function LicenseReciprocityPage(): React.ReactElement {
  const { userId } = useDefinedWorker();
  const iframeSrc = `https://v0-reciprocity-vercel-project.vercel.app/apply?userId=${encodeURIComponent(
    userId ?? ""
  )}`;

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        <StickyScrollPageHeader
          title="License Reciprocity Application"
          fallbackGoBackPath={ACCOUNTS_BASE_PATH}
          headerVariant="tertiary"
        />

        <PageContent>
          <div style={{ width: "100%", height: "90vh" }}>
            <iframe
              title="License Reciprocity Application"
              src={iframeSrc}
              style={{ border: 0, width: "100%", height: "100%" }}
            />
          </div>
        </PageContent>
      </PageWrapper>
    </ThemeProvider>
  );
}
